import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
 title: 'title'               the name show in submenu and breadcrumb (recommend set)
 icon: 'svg-name'             the icon show in the sidebar,
 }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    meta: {title: '首页', icon: 'home'},
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '欢迎页面', icon: 'home'}
    }
    ]
  }
]

export const asyncRouterMap = [
  {
    path: '',
    component: Layout,
    redirect: '/user',
    meta: {title: '个人中心', icon: 'home'},
    children: [{
      path: 'user',
      name: 'user',
      component: () => import('@/views/user/index'),
      meta: {title: '欢迎页面', icon: 'ums-admin'},
    }],
    hidden: true
  },

  {
    path: '/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '权限', icon: 'ums'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '用户列表', icon: 'ums-admin'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色列表', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表', icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '资源列表', icon: 'ums-resource'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      }
    ]
  },
  {
    path: '/fleet',
    component: Layout,
    redirect: '/fleet/members',
    name: 'fleet',
    meta: {title: '车队管理', icon: 'user'},
    children: [
      {
        path: 'members',
        name: 'FleetMembersList',
        component: () => import('@/views/fleet/members'),
        meta: {title: '成员列表', icon: 'sms-coupon'}
      }, {
        path: 'driverRate',
        name: 'driverRate',
        component: () => import('@/views/fleet/driverRate'),
        meta: {title: '薪资管理', icon: 'product-list'}
      }, {
        path: 'addOrUpdateDriver/:id?',
        name: 'addOrUpdateDriver',
        component: () => import('@/views/fleet/AddDriver'),
        meta: {title: '增改司机', icon: 'product-add'},
        props: true,
      }, {
        path: 'vehicleManagement',
        name: 'vehicleManagement',
        component: () => import('@/views/fleet/VehicleManagement'),
        meta: {title: '车辆管理', icon: 'product-list'},
        props: true,
      }, {
        path: 'addOrUpdateVehicle/:id?',
        name: 'addOrUpdateVehicle',
        component: () => import('@/views/fleet/AddOrUpdateVehicle'),
        meta: {title: '车辆新增', icon: 'product-add'},
        props: true,
      }, {
        path: 'addOrUpdateInsurance/:id?',
        name: 'addOrUpdateInsurance',
        component: () => import('@/views/fleet/AddOrUpdateInsurance'),
        meta: {title: '保单新增', icon: 'product-add'},
        props: true,
      }, {
        path: 'vehicleInsuranceManagement',
        name: 'vehicleInsuranceManagement',
        component: () => import('@/views/fleet/vehicleInsuranceManagement'),
        meta: {title: '保单管理', icon: 'product-add'},
        props: true,
      }, {
        path: 'addOrUpdateMaintenanceRecords/:id?',
        name: 'addOrUpdateMaintenanceRecords',
        component: () => import('@/views/fleet/AddOrUpdateMaintenanceRecords'),
        meta: {title: '新增维保记录', icon: 'product-add'},
        props: true,
      }, {
        path: 'vehicleMaintenanceRecords',
        name: 'vehicleMaintenanceRecords',
        component: () => import('@/views/fleet/vehicleMaintenanceRecords'),
        meta: {title: '维保管理', icon: 'product-list'},
        props: true,
      }, {
        path: 'vehicleUsageRecord',
        name: 'vehicleUsageRecord',
        component: () => import('@/views/fleet/vehicleUsageRecord'),
        meta: {title: '用车记录-后台', icon: 'product-list'},
        props: true,
      }, {
        path: 'vehicleUsageRecordPhone',
        name: 'vehicleUsageRecordPhone',
        component: () => import('@/views/fleet/vehicleUsageRecordPhone'),
        meta: {title: '用车记录', icon: 'product-list'},
        props: true,
      }, {
        path: 'tollFeeRecords',
        name: 'tollFeeRecords',
        component: () => import('@/views/fleet/tollFeeRecords'),
        meta: {title: '过路费记录', icon: 'product-list'},
        props: true,
      }, {
        path: 'fuelingRecords',
        name: 'fuelingRecords',
        component: () => import('@/views/fleet/fuelingRecords'),
        meta: {title: '油费记录', icon: 'product-list'},
        props: true,
      }, {
        path: 'shiftManagement',
        name: 'shiftManagement',
        component: () => import('@/views/fleet/shiftManagement'),
        meta: {title: '班表管理', icon: 'product-list'},
        props: true,
      }
    ]
  },
  {
    path: '/delivery',
    component: Layout,
    redirect: '/delivery/deliveryInfoList',
    name: 'delivery',
    meta: {title: '派送管理', icon: 'sms'},
    children: [
      {
        path: 'deliveryReport',
        name: 'deliveryReport',
        component: () => import('@/views/delivery/DeliveryReport'),
        meta: {title: '派送统计', icon: 'product-cate'},
      }, {
        path: 'deliveryInfoList',
        name: 'deliveryInfoList',
        component: () => import('@/views/delivery/DeliveryInfo'),
        meta: {title: '派送列表', icon: 'product-list'}
      }, {
        path: 'deliveryScheduleAdd',
        name: 'deliveryScheduleAdd',
        component: () => import('@/views/delivery/DeliverySchedule'),
        meta: {title: '班表管理', icon: 'product-add'},
      }, {
        path: 'deliveryWorkOrder',
        name: 'deliveryWorkOrder',
        component: () => import('@/views/delivery/DeliveryWorkOrder'),
        meta: {title: '工单管理', icon: 'product-list'},
      },
      {
        path: 'driverWorkOrder/:id?',
        name: 'driverWorkOrder',
        component: () => import('@/views/delivery/DriverWorkOrder'),
        meta: {title: '司机申报', icon: 'product-add'},
        props: true,
      }, {
        path: 'RoutesList',
        name: 'RoutesList',
        component: () => import('@/views/delivery/RoutesList'),
        meta: {title: '每日拉单', icon: 'product-list'},
      },
    ]
  },
  {
    path: '/finance',
    component: Layout,
    redirect: '/finance/dashboard',
    name: 'finance',
    meta: {title: '财务管理', icon: 'sms'},
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('@/views/finance/Dashboard'),
        meta: {title: '仪表盘', icon: 'dashboard'}
      }, {
        path: 'monthlySettlement',
        name: 'monthlySettlement',
        component: () => import('@/views/finance/monthlySettlement'),
        meta: {title: '月结', icon: 'product-cate'}
      }, {
        path: 'reportManage',
        name: 'reportManage',
        component: () => import('@/views/finance/ReportManage'),
        meta: {title: '报表管理', icon: 'product-cate'},
      },
      {
        path: 'reportStatistics',
        name: 'reportStatistics',
        component: () => import('@/views/finance/reportStatistics'),
        meta: {title: '报表统计', icon: 'product-cate'},
      },
      {
        path: 'uploadExcel',
        name: 'uploadExcel',
        component: () => import('@/views/finance/uploadExcel'),
        meta: {title: '上传EXCEl', icon: 'product-cate'},
      }
    ]
  },
  {
    path: '/thirdparty',
    component: Layout,
    redirect: '/thirdparty/ThirdPartyList',
    name: 'thirdparty',
    meta: {title: 'ThirdPartyManagement', icon: 'sms'},
    children: [
      {
        path: 'ThirdPartyList',
        name: 'ThirdPartyList',
        component: () => import('@/views/thirdparty/ThirdPartyList'),
        meta: {title: 'ThirdPartyList', icon: 'product-list'},
      },
      {
        path: 'ThirdPartyAccounting',
        name: 'ThirdPartyAccounting',
        component: () => import('@/views/thirdparty/ThirdPartyAccounting'),
        meta: {title: 'ThirdPartyAccounting', icon: 'product-list'},
      }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js